import { FormSelectId } from '@nexelem/form-components';
import { cn } from '@nexelem/utils';
import { useCustomTranslation } from '../../../../../hooks';
import { useGetAllQueuesAndAreasSuspense } from '../../GanttSimulation/hooks';
import { QueueAreaWithExternalId } from '../../types';

type AreaSelectProps = {
  valueSource?: 'id' | 'externalId';
};

export const AreaSelect = ({ valueSource = 'id' }: AreaSelectProps) => {
  const { tWrapper } = useCustomTranslation('common');
  const { areas } = useGetAllQueuesAndAreasSuspense();

  const options = areas
    .filter((area): area is Required<QueueAreaWithExternalId> => !!area.externalId.id)
    .map((area) => {
      return {
        id: valueSource === 'externalId' ? area.externalId.id : area.id,
        label: area.name,
      };
    });

  return (
    <FormSelectId
      required
      className="w-full"
      label={tWrapper('area')}
      maxWidth="full"
      name="queueAreaId"
      options={options}
      placeholder={tWrapper('select')}
      renderOption={({ className, ...props }, option) => {
        const area = areas.find((area) =>
          valueSource === 'externalId' ? area.externalId.id === option.id : area.id === option.id,
        );
        return (
          <li className={cn(className, 'inline-flex items-center gap-2')} key={option.id} {...props}>
            <span className="size-4 rounded-full" style={{ backgroundColor: `#${area?.hex}` }} />
            <span>{option.label}</span>
          </li>
        );
      }}
    />
  );
};
